export default class CollectedController {
  constructor($state, ContentService, Notification, $translate) {
    this.state = $state;
    this.service = ContentService;
    this.notify = Notification;
    this.trans = $translate.instant;
  }

  $onInit() {
    this.subscriptions = [];

    this.dtts = [];
    this.subscriptions.push(
      this.collectedObservable.subscribe((data) => {
          this.dtts = data.dtts;
      })
    );
    this.activeTab = 'A';
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  processNow(dtt) {
    this.subscriptions.push(
      this.service.processJournals().subscribe(
        (resp) => this.notify.success(_('Los journals están siendo procesados')),
        () => this.notify.error(_("Ha ocurrido un error tratando de procesar los journals, intente nuevamente"))
      )
    );
  }
}

 CollectedController.$inject = ['$state', 'ContentService', 'Notification', '$translate'];



// WEBPACK FOOTER //
// ./src/app/pages/collected/collected.controller.js